import { render } from "./TermsOfUse.vue?vue&type=template&id=9b385d44"
const script = {}

import exportComponent from "/home/ubuntu/bookonline/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__